import React from 'react'
import { Button, RealEstateDataPageComponentData } from 'types'
import Form from '@components/form/6'

interface ExternalProps {
  data: any
  from: string
  title: string
  paragraph: string
  underlineMode: boolean
  basicButton?: boolean
  form: any
  button: Button
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const FormComponent = (props: CombinedProps) => {
  return (
    <Form
      {...props}
      basicButton={true}
    />
  )
}

export default FormComponent
